import { useTailwindBreakpoint } from 'custom-hooks/useTailwindBreakpoint'
import { HuePicker, TwitterPicker } from 'react-color'
import { base, brand } from 'utils/theme'

type Props = {
  color: string
  isOpen: boolean
  onChangeColor: (color: string) => void
  onClose: () => void
}

const colors = [
  ...Object.values(base),
  ...Object.entries(brand).reduce((prev, [_, value]): string[] => [...prev, ...Object.values(value)], [] as string[])
]

function ColorPicker({ color, isOpen, onChangeColor, onClose }: Props) {
  const { isLessOrEqualTo } = useTailwindBreakpoint()

  const isPopupUp = isLessOrEqualTo('md')

  if (!isOpen) return null

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: '2',
        ...(isPopupUp
          ? {
              bottom: '100%'
            }
          : {
              top: 'calc(100% + 10px)'
            })
      }}>
      {/* Overlay */}
      <div
        style={{
          position: 'fixed',
          inset: 0
        }}
        onClick={() => onClose()}
      />
      <TwitterPicker
        width='320px'
        triangle={isPopupUp ? 'hide' : 'top-left'}
        styles={{
          default: {
            // Color item
            swatch: {
              boxSizing: 'border-box',
              borderWidth: 1,
              borderStyle: 'solid',
              borderColor: 'lightgray'
            }
          }
        }}
        colors={colors}
        color={color}
        onChange={c => onChangeColor(c.hex)}
      />
      <div
        className='flex-grow p-5 bg-white rounded'
        style={{
          boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 4px'
        }}>
        <HuePicker
          width='100%'
          color={color}
          onChange={c => onChangeColor(c.hex)}
          onChangeComplete={c => onChangeColor(c.hex)}
        />
      </div>
    </div>
  )
}

export default ColorPicker
